module.exports = __webpack_public_path__ + "img/confetti.ee292c27.svg";